import { Theme, ThemeOptions, createTheme } from '@material-ui/core/styles';
import { merge } from 'ts-deepmerge';
import { theme as defaultTheme } from '../../assets/themes/theme';

// TODO: Turn this into a theme provider by wrapping the mui themeprovider
const getTheme = (brandTheme: ThemeOptions = {}): Theme => {
    // Deep merge the themes together
    const themeOptions: ThemeOptions = merge(defaultTheme, brandTheme) as unknown as ThemeOptions;

    return createTheme(themeOptions);
};

export default getTheme;
